import type { TranslationKeys } from './en'

export const fr: TranslationKeys = {
  schoolSubtitle: 'Accédez via l\'application Agenda1',
  scanQrCode: 'Pointez l\'appareil photo de votre téléphone vers le code QR',
  or: 'ou',
  downloadApp: 'Téléchargez l\'application depuis les boutiques officielles',
  appStoreBadgeUrl: 'https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/fr-fr?size=250x83',
  appStoreBadgeAlt: 'Télécharger dans l\'App Store',
  playStoreBadgeUrl: 'https://play.google.com/intl/fr_fr/badges/static/images/badges/fr_badge_web_generic.png',
  playStoreBadgeAlt: 'Disponible sur Google Play',
  openAppStore: 'Ouvrir dans l\'App Store',
  openPlayStore: 'Ouvrir sur Google Play',
  printQrCode: 'Imprimer le code QR',
  schoolCode: 'Code de l\'école',
  scanInstruction: 'Pointez l\'appareil photo de votre téléphone vers le code QR ci-dessus',
  accessUrl: 'ou accédez à',
  needHelp: 'Besoin d\'aide? Contactez le support',
  support: 'support@agenda1.app',
  copyright: `© ${new Date().getFullYear()} Agenda1. Tous droits réservés.`,
  // Mobile 2-step flow
  step1Title: 'Téléchargez l\'App',
  step1Description: 'Si vous ne l\'avez pas encore, téléchargez Agenda1',
  step2Title: 'Ouvrez l\'École',
  step2Description: 'Appuyez pour ouvrir l\'école dans l\'app',
  openSchoolButton: 'Ouvrir l\'École dans l\'App',
  alreadyHaveApp: 'Vous avez déjà l\'app?'
}
